import axios from './axios';

async function userInfo(configuration = {}) {
  const config = {
    method: 'get',
    url: `/auth/oneaccount/userinfo`,
  };

  if (configuration.headers) {
    config.headers = { ...config.headers, ...configuration.headers };
  }

  return axios(config)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.log(error);
      throw error;
    });
}

export default {
  userInfo,
};
